import React, { useState } from 'react';
import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import { AutoShipTipContainer } from './AutoShip.styled';
import Icon from '../../atoms/Icon/Icon';

const AutoShipToolTip = () => {
  const [isLabelOpen, setIsLabelOpen] = useState(false);
  return (
    <Tooltip
      isOpen={isLabelOpen}
      bgColor={'var(--bg-dark-blue)'}
      label={
        <AutoShipTipContainer>
          <Box p={4}>
            With AutoShip, products are automatically delivered on your schedule.
            <ul>
              <li>Save up to 20% on AutoShip orders</li>
              <li>Choose your own delivery schedule</li>
              <li>Cancel or edit AutoShip anytime</li>
              <li>Enjoy convenient recurring deliveries!</li>
            </ul>
            <i>
              *a valid original prescription is required prior to dispensing medication AutoShip
              orders, discount excludes prescription medications
            </i>
          </Box>
        </AutoShipTipContainer>
      }
    >
      <Flex cursor={'pointer'} className="autoship" alignItems={'center'} gap={2}>
        <Text
          onMouseEnter={() => setIsLabelOpen(true)}
          onMouseLeave={() => setIsLabelOpen(false)}
          onClick={() => setIsLabelOpen(!isLabelOpen)}
          color={'var(--navy-06)'}
          fontSize={14}
        >
          What is Autoship?
        </Text>
        <Icon symbol="chevDown" />
      </Flex>
    </Tooltip>
  );
};
export default AutoShipToolTip;
